import { NavLink, useLocation } from "react-router-dom";
import {
  Bell,
  BriefcaseBusiness,
  ChevronRight,
  CircleDollarSign,
  FileBarChart2,
  LayoutDashboard,
  LogOut,
  Plus,
  Settings2,
  Users,
  Wallet,
} from "lucide-react";

const LINKS = [
  { to: "/", label: "Genel Bakış", icon: LayoutDashboard, exact: true },
  { to: "/turlar", label: "Tur Operasyonları", icon: BriefcaseBusiness },
  { to: "/musteriler", label: "Müşteriler & Satışlar", icon: Users },
  { to: "/finans", label: "Finans Merkezi", icon: CircleDollarSign },
  { to: "/hesaplar", label: "Banka Hesapları", icon: Wallet },
  { to: "/raporlar", label: "Finansal Raporlar", icon: FileBarChart2 },
];

export default function Shell({ user, pendingCount, upcomingCount, onLogout, onNew, children }) {
  const location = useLocation();
  const current = LINKS.find((x) => (x.exact ? x.to === location.pathname : location.pathname.startsWith(x.to))) || LINKS[0];
  const initials = (user?.name || user?.email || "A").split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase();

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <div className="brand-mark">V</div>
          <div>
            <strong>voyage<span>360</span></strong>
            <small>ACENTE YÖNETİMİ</small>
          </div>
        </div>
        <div className="workspace">
          <span className="eyebrow">ÇALIŞMA ALANI</span>
          <div className="workspace-row">
            <div className="workspace-icon">S</div>
            <div>
              <b>Serenity Travel</b>
              <small>Merkez Ofis</small>
            </div>
            <ChevronRight size={15} />
          </div>
        </div>
        <nav className="nav-list">
          {LINKS.map(({ to, label, icon: Icon, exact }) => (
            <NavLink
              key={to}
              to={to}
              end={!!exact}
              data-testid={`nav-${to.replace("/", "") || "dashboard"}`}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <Icon size={18} />
              <span>{label}</span>
              {label === "Finans Merkezi" && pendingCount > 0 && <i data-testid="finance-pending-badge">{pendingCount}</i>}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-bottom">
          <NavLink to="/ayarlar" data-testid="nav-settings">
            <Settings2 size={18} />
            <span>Ayarlar</span>
          </NavLink>
          <div className="help-box">
            <span>Rol: {user?.role || "Personel"}</span>
            <b>
              {user?.email}
              <ChevronRight size={14} />
            </b>
          </div>
        </div>
      </aside>
      <main className="main">
        <header className="topbar">
          <div>
            <span className="breadcrumb">
              Voyage360 <ChevronRight size={13} /> {current.label}
            </span>
            <h1>{current.label}</h1>
          </div>
          <div className="top-actions">
            <button className="icon-button" data-testid="notifications-button" title="Yaklaşan turlar">
              <Bell size={19} />
              {upcomingCount > 0 && <em data-testid="notifications-count">{upcomingCount}</em>}
            </button>
            <div className="role-switch" data-testid="role-display">
              <span>Rol:</span>
              <b>{user?.role}</b>
            </div>
            <div className="avatar" data-testid="user-avatar">{initials}</div>
            <button className="primary-button" onClick={onNew} data-testid="new-record-button">
              <Plus size={17} /> Yeni Kayıt
            </button>
            <button className="icon-button logout-top" onClick={onLogout} data-testid="logout-button" title="Çıkış yap">
              <LogOut size={17} />
            </button>
          </div>
        </header>
        <div className="content">{children}</div>
      </main>
    </div>
  );
}
